var exports = {
  "r": "x8b4e8595--35368f--providers",
  "_": "x8b4e8595--35368f--img",
};

module.exports = exports;
